import React, { useState } from 'react';
import {
  Button,
  CondensedLarge,
  ContextMenu,
  ContextMenuItem,
  Suspense,
  ClipboardUtil,
  ToastUtil,
} from '@axiom/ui';
import type { Account, User, AfcSubmission } from '@axiom/validation';

import { isEnvoyUser } from '../../utils/roles-util';
import { SubmissionPdfDownload } from '../SubmissionPdfDownload/SubmissionPdfDownload';

export type EngagementsShareContextMenuProps = {
  user?: User;
  account?: Account;
  currentSubmission?: AfcSubmission;
  onClickInviteToAccount: () => void;
  onClickOpenInAhq?: () => void;
};
export const EngagementsShareContextMenu = ({
  user,
  onClickInviteToAccount,
  onClickOpenInAhq,
  currentSubmission,
}: EngagementsShareContextMenuProps) => {
  const [downloadPdf, setDownloadPdf] = useState(false);

  const handleCopyLink = async () => {
    await ClipboardUtil.copy({
      text: window.location.href,
    });

    ToastUtil.add({
      name: 'COPIED_URL',
      type: 'info',
      children: <CondensedLarge>Link copied!</CondensedLarge>,
    });
  };

  const handleDownloadMatches = () => {
    setDownloadPdf(!downloadPdf);

    ToastUtil.add({
      name: 'DOWNLOAD_PDF',
      type: 'info',
      children: (
        <CondensedLarge>
          Your PDF is being created - it will download automatically when ready.
        </CondensedLarge>
      ),
    });
  };

  return (
    <>
      <ContextMenu
        name="ACTIONS_MENU"
        direction="left"
        fluid
        anchor={
          <Button
            fluid
            pattern="primary"
            variation="minimal"
            name="ACTION_BUTTON"
            icon="open"
          >
            Share
          </Button>
        }
      >
        <ContextMenuItem name="copy-link-option" onClick={handleCopyLink}>
          Copy link
        </ContextMenuItem>
        {currentSubmission?.salesforceId ? (
          <ContextMenuItem
            name="share-option"
            onClick={() => {
              onClickInviteToAccount();
            }}
          >
            Invite Others to Account
          </ContextMenuItem>
        ) : null}
        <ContextMenuItem name="download-pdf" onClick={handleDownloadMatches}>
          Download All Matches
        </ContextMenuItem>
        {isEnvoyUser(user) && onClickOpenInAhq ? (
          <ContextMenuItem name="AHQ_LINK" onClick={onClickOpenInAhq}>
            Open in AHQ
          </ContextMenuItem>
        ) : null}
      </ContextMenu>
      {downloadPdf ? (
        <Suspense fallback={null}>
          <div className="k-pdf-export">
            <SubmissionPdfDownload
              name="SUBMISSION_PDF_DOWNLOAD"
              onSave={() => {
                setDownloadPdf(!downloadPdf);
              }}
            />
          </div>
        </Suspense>
      ) : null}
    </>
  );
};
